import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { SimpleDto } from 'generated/openApi';
import ApiService from 'services/apiService';

interface DashboardSchoolYearContextValue {
    schoolYear: number | undefined;
    schoolYears: SimpleDto[];
    setSchoolYear: (schoolYear: number) => void;
}

const DashboardSchoolYearContext = createContext<DashboardSchoolYearContextValue | undefined>(undefined);

export const DashboardSchoolYearProvider = ({ children }: { children: ReactNode }) => {
    const [schoolYear, setSchoolYear] = useState<number | undefined>();
    const [schoolYears, setSchoolYears] = useState<SimpleDto[]>([]);

    useEffect(() => {
        ApiService.students.getFilterResource().then((resource) => {
            const options = resource.schoolYearsWithActive || [];
            const activeOptionIndex = options.findIndex((option) => option.name.includes('Active'));
            const activeSchoolYear = activeOptionIndex >= 0 ? options[activeOptionIndex + 1]?.id : undefined;
            const availableYears = options
                .filter((option) => !activeSchoolYear || option.id <= activeSchoolYear)
                .slice(0, 6);

            setSchoolYears(availableYears);
            setSchoolYear(activeSchoolYear || availableYears[0]?.id);
        });
    }, []);

    return (
        <DashboardSchoolYearContext.Provider value={{ schoolYear, schoolYears, setSchoolYear }}>
            {children}
        </DashboardSchoolYearContext.Provider>
    );
};

export const useDashboardSchoolYear = () => {
    const context = useContext(DashboardSchoolYearContext);
    if (!context) throw new Error('useDashboardSchoolYear must be used within DashboardSchoolYearProvider');
    return context;
};
